module.exports = __webpack_public_path__ + "img/score40.393e0efa.png";